import React from 'react';

import { useFilteredEmailRecipients } from './useFilteredEmailRecipients';

import RecipientInputField from '../ComposeEmailForm/Fields/RecipientInput/RecipientInputField/RecipientInputField';

type RecipientInputProps = {
  projectId: string;
  setRecipients: (recipients: any) => void;
  recipients: any[];
  fieldLabel: string;
  isRequired?: boolean;
  LastComponentSlot?: React.ReactNode;
  onBlur?: (value: string, tags: any[]) => void;
};
const RecipientInput = ({
  projectId,
  isRequired = false,
  setRecipients,
  recipients,
  ...otherProps
}: RecipientInputProps) => {
  const { recipientsOptions, setFilters } = useFilteredEmailRecipients({
    projectId,
  });

  const handleSetFilter = ({ withNonMembers, name }) => {
    setFilters({
      withNonMembers,
      name,
    });
  };

  return (
    <RecipientInputField
      onSetFilter={handleSetFilter}
      recipientsOptions={recipientsOptions}
      isRequired={isRequired}
      setRecipients={setRecipients}
      recipients={recipients}
      {...otherProps}
    />
  );
};

export default RecipientInput;
